import mfaAdNavigation from "./mfaAdNavigation";
import mfaDbNavigation from "./mfaDbNavigation";
import mfaRadiusNavigation from "./mfaRadiusNavigation";
import mfaPamNavigation from "./mfaPamNavigation";
import mfaApplicationsNavigation from "./mfaApplicationsNavigation";
import { isAdminUser } from "../../../../utils/helpers";

export const MFA_MODES = [
  {
    key: "mfa_ad",
    label: "Identity",
    nav: mfaAdNavigation,
    defaultRoute: "/pam/directory",
    // Where switching to this mode lands: its dashboard.
    dashboardRoute: "/",
    allowedPathPrefixes: [
      "/pam/directory",
      "/pam/users",
      "/pam/policy/v2",
      // The shared policy screens; the sidebar also switches to the product
      // named in /pam/policies/<product> (layout/sideBar.jsx).
      "/pam/policies",
      "/pam/policy-logs",
      "/pam/auth-logs",
      "/pam/settings",
    ],
  },
  {
    key: "mfa_db",
    label: "Database",
    nav: mfaDbNavigation,
    hideDashboardHeader: true,
    defaultRoute: "/pam/databases",
    // Where switching to this mode lands: its dashboard.
    dashboardRoute: "/pam/databases/dashboard",
    allowedPathPrefixes: [
      "/pam/databases",
      "/pam/policy/v2",
      // The shared policy screens; the sidebar also switches to the product
      // named in /pam/policies/<product> (layout/sideBar.jsx).
      "/pam/policies",
      "/pam/policy-logs",
      "/pam/auth-logs",
      "/pam/settings",
    ],
  },
  {
    key: "mfa_radius",
    label: "Radius",
    nav: mfaRadiusNavigation,
    defaultRoute: "/pam/radius",
    // Where switching to this mode lands: its dashboard.
    dashboardRoute: "/",
    allowedPathPrefixes: [
      "/pam/directory",
      "/pam/users",
      "/pam/radius",
      "/pam/policy/v2",
      // The shared policy screens; the sidebar also switches to the product
      // named in /pam/policies/<product> (layout/sideBar.jsx).
      "/pam/policies",
      "/pam/policy-logs",
      "/pam/auth-logs",
      "/pam/settings",
    ],
  },
  {
    // PAM is not an MFA method, but it shares this mode switcher — it is the
    // fourth product surface alongside AD / Database / Radius. Its nav carries
    // the SSH proxy onboarding, jump servers, endpoints and credential rotation.
    key: "mfa_pam",
    label: "PAM",
    nav: mfaPamNavigation,
    defaultRoute: "/pam/endpoint",
    // Where switching to this mode lands: its dashboard.
    dashboardRoute: "/",
    allowedPathPrefixes: [
      "/pam/endpoint",
      "/pam/endpointsUsers",
      "/pam/endpointGroups",
      // Old links only: both redirect (see pamRouter).
      "/pam/credentialRotation",
      "/pam/elevation",
      "/pam/jumpServer",
      // Old links only: redirects to /pam/endpoint (see pamRouter).
      "/pam/myAccess",
      "/pam/policy",
      "/pam/policies",
      "/pam/auth-logs",
      "/pam/settings",
    ],
  },
  {
    // Single sign-on (OpenID Connect, SAML) and the MFA API for the tenant's
    // own applications. The idp API answers 403 to anyone but an
    // administrator, so the product is offered to administrators only.
    key: "mfa_apps",
    label: "Applications",
    nav: mfaApplicationsNavigation,
    adminOnly: true,
    // Its own dashboard (first nav item) replaces the shared "/" header entry.
    hideDashboardHeader: true,
    defaultRoute: "/pam/applications",
    // Where switching to this mode lands: its dashboard.
    dashboardRoute: "/pam/applications/dashboard",
    allowedPathPrefixes: ["/pam/applications", "/pam/policies", "/pam/users", "/pam/auth-logs", "/pam/settings"],
  },
];

// The modes this user may switch to.
export const availableMfaModes = () => MFA_MODES.filter((m) => !m.adminOnly || isAdminUser());

export const isMfaMode = (mode) => typeof mode === "string" && mode.startsWith("mfa_");

export const getMfaMode = (key) => MFA_MODES.find((m) => m.key === key);
